import { Typography } from 'antd';
import { ContainerOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    onClose: () => void;
    onArchive: () => void;
};

const ArchiveJobModal = ({ open, onClose, onArchive }: Props) => {
    return (
        <ConfirmationModal
            open={open}
            icon={<ContainerOutlined />}
            title="Archive Job?"
            confirmButtonText="Archive"
            onConfirm={onArchive}
            onCancel={onClose}
            content={<Typography.Text>The job will be added to the archive.</Typography.Text>}
        />
    );
};

export default ArchiveJobModal;
